import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-10 pt-32 pb-20 flex items-center justify-center">
      <div className="max-w-[1440px] mx-auto flex flex-col items-center text-center py-20">
        <span className="font-heading font-bold text-7xl md:text-9xl text-primary-100 select-none">
          404
        </span>
        <h1 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950">
          这个页面还没有生成
        </h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}